/**
 * Returns true when the object is a minimal selection payload (uuid-only),
 * e.g. from URL or when iframe sends a pre-selected row not on current page.
 */
import type { YesObject } from '@yes.technology/react-toolkit'

export type MinimalSelectionOption = { uuid: string }

export function isMinimalSelectionOption(
  obj: YesObject | MinimalSelectionOption
): obj is MinimalSelectionOption {
  const keys = Object.keys(obj)
  return keys.length === 1 && 'uuid' in obj && typeof obj.uuid === 'string'
}
